<label class="checkbox-container">
  <input class="checkbox-input" type="checkbox" [ngModel]="checked" (ngModelChange)="onModelChange($event)" />
  <div class="checkbox-border" [ngClass]="{ checked: checked }">
    @if (checked) {
      <span class="checkbox-filling" inlineSVG="/icons/icon-success-2.svg"></span>
    }
  </div>
  <ng-content> </ng-content>
</label>
